import { relativeTimeFa } from '../../lib/relativeTime'
import styles from './HeroStatusCard.module.css'

export type HeroState = 'idle' | 'ok' | 'queued' | 'removed'

interface HeroStatusCardProps {
  state: HeroState
  serialNumber: string
  capturedAt: string
  onUndo: () => void
  /** False while an undo is impossible — nothing to undo, or one already in flight. */
  canUndo: boolean
}

const COPY: Record<Exclude<HeroState, 'idle'>, { title: string; undo: string }> = {
  // The three strings are the artboard's, verbatim.
  ok: { title: '✓ ثبت شد', undo: 'لغو آخرین اسکن' },
  queued: { title: '✓ روی دستگاه ذخیره شد · منتظر شبکه', undo: 'لغو آخرین اسکن' },
  removed: { title: '− از پالت خارج شد', undo: 'بازگردانی' },
}

/**
 * The one element the operator looks at. Its position never moves between states, because
 * the design's governing principle is that the operator mostly is not looking at the
 * screen — so the card has to be findable without reading it.
 *
 * `queued` is not a loading state dressed up as one: the scan IS saved, on the device,
 * and the card says so. There are no spinners anywhere in this app.
 */
export function HeroStatusCard({
  state,
  serialNumber,
  capturedAt,
  onUndo,
  canUndo,
}: HeroStatusCardProps) {
  if (state === 'idle') {
    return (
      <div className={styles.idle} role="status">
        آماده اسکن · کارت وضعیت پس از نخستین اسکن اینجا ظاهر می‌شود
      </div>
    )
  }

  const copy = COPY[state]

  return (
    <div className={`${styles.card} ${styles[state]}`} role="status" aria-live="polite">
      <div className={styles.title}>{copy.title}</div>
      <div className={styles.serial}>{serialNumber}</div>
      <div className={styles.footer}>
        <span>{relativeTimeFa(capturedAt)}</span>
        <button type="button" className={styles.undo} onClick={onUndo} disabled={!canUndo}>
          {copy.undo}
        </button>
      </div>
    </div>
  )
}
